import React, { Component } from "react";
import { MdClear } from "react-icons/md";
import "./Attachment.scss";

export default class Attachment extends Component {
  handleCloseIconClick = () => {
    this.props.removeAttachedFile();
  };

  render() {
    return (
      <div className="attached-content" data-testid="attached-content">
        <div className="file-name-ctr">
          <div className="text" data-testid="text">
            {this.props.fileName}
          </div>
          <div className="cross" onClick={this.handleCloseIconClick}>
            <MdClear size="1.2em" />
          </div>
        </div>
      </div>
    );
  }
}
